import { JUST_WALLET } from '@/config'
import { WalletUtils } from '@/api/wallet/walletUtils'

export const LOGIN_TYPE_WALLET = 'wallet'
export const LOGIN_TYPE_PASSWORD = 'password'

export function setLoginType(type) {
  localStorage.setItem('loginType', type)
}

export function clearLoginType() {
  localStorage.removeItem('loginType')
}

/** 是否为钱包签名授权登录（非账号密码登录） */
export function isWalletAuthLogin(userInfo) {
  const loginType = localStorage.getItem('loginType')
  if (loginType === LOGIN_TYPE_WALLET) {
    return true
  }
  if (loginType === LOGIN_TYPE_PASSWORD) {
    return false
  }

  // 兼容旧会话：仅钱包模式或 DApp 环境默认为钱包登录
  if (JUST_WALLET || isDappSupported()) {
    return true
  }

  const userName = (userInfo && userInfo.userName) || ''
  return /^0x[a-fA-F0-9]{40}$/.test(userName) || /^T[A-Za-z1-9]{33}$/.test(userName)
}

/** 当前环境是否具备 DApp 钱包注入（以太坊 / Tron） */
export function isDappSupported() {
  if (typeof window === 'undefined') {
    return false
  }
  return (
    WalletUtils.isEthereumWalletAvailable() ||
    WalletUtils.isTronLinkAvailable()
  )
}

/**
 * 需要登录时的入口路径：
 * - JUST_WALLET：仅钱包，一律 /empty
 * - 否则：有 DApp 能力走 /empty，否则走账号登录页
 */
export function getAuthEntryPath() {
  if (JUST_WALLET) {
    return '/empty'
  }
  return isDappSupported() ? '/empty' : '/pass/login'
}

/** 未登录时允许访问的路径（除 OAuth 等白名单外） */
export function isAllowedPathWithoutLogin(path, dapp) {
  if (path === '/api/loginCallback/google') {
    return true
  }
  if (JUST_WALLET || dapp) {
    return path === '/empty'
  }
  return (
    path === '/pass/login' ||
    path === '/pass/register' ||
    path === '/pass/reset'
  )
}
